import { useState } from 'react';
import { clearAllAuthData, usernameStorage } from '../../utils/encryptedCookie';

const useNavigationActions = (navigate) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleOffcanvasClose = () => setShowOffcanvas(false);
  const handleOffcanvasShow = () => setShowOffcanvas(true);

  const handleLogoutConfirm = () => {
    const username = usernameStorage.get() || '';
    clearAllAuthData();
    if (username) {
      sessionStorage.removeItem(`pinVerified_${username}`);
    }
    sessionStorage.clear();
    navigate('/login');
    setShowLogoutModal(false);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const handleModalClose = () => {
    setShowLogoutModal(false);
  };

  const navigateTo = (path) => {
    navigate(path);
    setShowOffcanvas(false);
  };

  return {
    showOffcanvas,
    showLogoutModal,
    handleOffcanvasClose,
    handleOffcanvasShow,
    handleLogoutConfirm,
    handleLogout,
    handleModalClose,
    navigateTo,
  };
};

export default useNavigationActions;